import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-dynamic-slide-toggle',
  templateUrl: './dynamic-slide-toggle.component.html',
  styleUrls: ['./dynamic-slide-toggle.component.scss']
})
export class DynamicSlideToggleComponent implements OnInit {
  @Input() field: any;
  form!: FormGroup;
  color = '#00FF00'

  constructor(private formGroupDirective: FormGroupDirective) { this.form = formGroupDirective.control; }

  ngOnInit(): void {
  }

}
